module.exports = __webpack_public_path__ + "static/june-2-b86248c50940d5f973f82d1f28aeac16.png";